module.exports = __webpack_public_path__ + "img/bb_g1_t_eyes-04.e26677d9.svg";